export enum Funcionalidade {
  Usuario = 1,
  Perfil = 2,
  Forum_Comunidade_Associado = 3,
  Forum_Comissoes_Tecnicas = 4,
  Forum_Grupo_Trabalho = 5,
  News = 6,
  Atas = 7,
  AccessoBackoffice = 8,
  Forum_Moderacao = 9,
  ChamadoMeusChamados = 11,
  ChamadoModeracao = 12,
  Candidatos = 13,
  Eventos = 15,
}
